import axios from "axios";

class WithdrawalService {

    
  static async getAllWithdrawals(data) {
    try {
      const result = await axios.get("/withdrawal/getAllWithdrawals", {params: data });
      return result.data;
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  }

  static async getAllStockAsigned(userId) {
    try {
      const result = await axios.get("/withdrawal/getAllStockAsigned", {
        params: { userId },
      });
      return result.data;
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  }

  static async getArea(userId) {
    try {
      const result = await axios.get("/withdrawal/getArea", {
        params: { userId },
      });
      return result.data;
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  }

  //procedemos a guardar
 static async createWithdrawal(payload) {
    try {
      const res = await axios.post("/withdrawal/create", payload);
      return res.data;
    } catch (err) {
      console.error(err);
      return Promise.reject(err);
    }
  }

  //aprobar o rechazar
  static async approveWithdrawal(data) {
    try {
      const res = await axios.post("/withdrawal/approve", data);
      return res.data;
    } catch (err) {
      console.error(err);
      return Promise.reject(err);
    }
  }
}

export default WithdrawalService;
